import React from 'react'
import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {toAbsoluteUrl} from '../../../../../../_gori/helpers'
import {Button} from '../../../../../../_gori/partials/widgets'

type Props = {
  show: boolean
  handleClose: () => void
  handleDisconnectStore: () => void
  storeName: string | null
}

const DisconnectStoreModal: React.FC<Props> = ({
  show,
  handleClose,
  handleDisconnectStore,
  storeName,
}) => {
  const intl = useIntl()

  return (
    <>
      <Modal
        id='gori_modal_notice_create_label'
        tabIndex={-1}
        aria-hidden='true'
        centered
        dialogClassName='modal-size-lg h-auto'
        contentClassName='modal-padding'
        show={show}
        backdrop='static'
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title bsPrefix={'fw-bolder fs-1'}>
            {intl.formatMessage({id: 'DISCONNECT_STORE'})}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='mx-10 my-5 d-flex flex-column justify-content-center align-items-center fs-4'>
            <div className='mb-5'>
              <img src={toAbsoluteUrl('/media/gori/dashboard/error_balance.svg')} alt='img' />
            </div>
            <p className='text-center'>
              {intl.formatMessage(
                {id: 'ARE_YOU_SURE_YOU_WANT_TO_DISCONNECT'},
                {store: <span className='fw-bolder'>{storeName}</span>}
              )}
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className='d-flex justify-content-end'>
            <Button
              className='btn btn-advanced-secondary me-2'
              label={intl.formatMessage({id: 'CANCEL'})}
              loadingText={intl.formatMessage({id: 'CANCEL'})}
              event={handleClose}
            />
            <Button
              className='btn btn-advanced-primary'
              label={intl.formatMessage({id: 'REMOVE'})}
              loadingText={intl.formatMessage({id: 'REMOVE'})}
              event={handleDisconnectStore}
            />
          </div>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export {DisconnectStoreModal}
